import script from "./promoBannerSplit.vue?vue&type=script&setup=true&lang=js"
export * from "./promoBannerSplit.vue?vue&type=script&setup=true&lang=js"

import "./promoBannerSplit.vue?vue&type=style&index=0&id=7655a248&scoped=true&lang=css"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7655a248"]])

export default __exports__